import React from 'react';

const Heading = ({ 
  children, 
  level = 2,
  className = 'font-medium',
  hasUnderline = false,
  ...props 
}) => {
  const baseStyles = "font-normal ";
  
  const sizes = {
    1: "text-4xl md:text-5xl mb-6",
    2: "text-3xl md:text-4xl mb-5",
    3: "text-2xl md:text-3xl mb-3",
    4: "text-xl md:text-2xl mb-2",
    5: "text-lg md:text-xl mb-2",
    6: "text-base md:text-lg mb-2",
  };
  
  const underlineStyles = hasUnderline ? 'pb-2 border-b border-yellow-500 inline-block' : '';
  
  const headingStyles = `${baseStyles} ${sizes[level]} ${underlineStyles} ${className}`;
  
  const HeadingTag = `h${level}`;
  
  return (
    <HeadingTag className={headingStyles} {...props}>
      {children}
    </HeadingTag>
  );
};

export default Heading;
